import { render, staticRenderFns } from "./ThreeTable.vue?vue&type=template&id=0359e882&scoped=true"
import script from "./ThreeTable.vue?vue&type=script&lang=js"
export * from "./ThreeTable.vue?vue&type=script&lang=js"
import style0 from "./ThreeTable.vue?vue&type=style&index=0&id=0359e882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0359e882",
  null
  
)

export default component.exports